var map = {
	"./35.svg": 91300,
	"./36.svg": 34423,
	"./37.svg": 46886,
	"./38.svg": 21745,
	"./39.svg": 58944,
	"./40.svg": 17812,
	"./41.svg": 39445,
	"./42.svg": 2806,
	"./43.svg": 66023,
	"./44.svg": 63624,
	"./45.svg": 59641
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 14560;